export default __webpack_public_path__ + "static/media/banner-finish-2.0a899a67.png";